import api from '../client'

export async function fetchCompanyOptions(search = '', page = 1, pageSize = 20) {
  const { data } = await api.get('/options/companies', {
    params: { search, page, page_size: pageSize },
  })
  const rawItems = Array.isArray(data) ? data : Array.isArray(data?.items) ? data.items : []
  const items = rawItems.map((item) => ({
    value: String(item.id),
    label: item.name || item.code || String(item.id),
  }))
  const hasMore = rawItems.length === pageSize
  return { items, hasMore }
}
